import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PerfilRecursoSeguranca } from '../../perfil-recurso-seguranca/perfil-recurso-seguranca.model';
import { Perfil } from '../../perfil/perfil.model';
import { PerfilService } from '../../perfil/perfil.service';
import { RecursoSeguranca } from '../recurso-seguranca.model';
import { RecursoSegurancaService } from '../recurso-seguranca.service';
import { Frm } from '../../components/frm/frm.interface';
import { MensagemService, ProgressoService, StringUtils } from 'maestro-ng';
import { SelectItem } from 'primeng/api/selectitem';
import { SelectItemService } from '../../services/select-item.service';
import { RecursoSegurancaDominio } from '../../models/recurso-seguranca-dominio.enum';
import { RecursoSegurancaMetodo } from '../../models/recurso-seguranca-metodo.enum';
import { Location } from '@angular/common';

@Component({
  selector: 'app-recurso-seguranca-frm',
  templateUrl: './recurso-seguranca-frm.component.html',
  styleUrls: ['./recurso-seguranca-frm.component.css'],
})
export class RecursoSegurancaFrmComponent implements OnInit, Frm<RecursoSeguranca, number> {
  perfilRecursosSeguranca: PerfilRecursoSeguranca[] = [];
  submit = false;
  invalid: any = {};

  entidade: RecursoSeguranca;
  isInsercao: boolean;

  public dominioItens: SelectItem[];
  public metodoItens: SelectItem[];
  instanciaItens: SelectItem[];

  constructor(
    public service: RecursoSegurancaService,
    public perfilService: PerfilService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private route: ActivatedRoute,
    private selectItemService: SelectItemService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.recuperarPerfis(+params['id']);
      } else {
        this.recuperarPerfis(undefined);
      }
    });
    // this.entidade = new RecursoSeguranca();
    this.isInsercao = true;
    this.dominioItens = this.selectItemService.getDominios();
    this.metodoItens = this.selectItemService.getMetodos();
  }

  public recuperarPerfis(recursoSegurancaId: number) {
    this.progressoService.modal();
    if (recursoSegurancaId === undefined) {
      this.perfilService
        .recuperarItens()
        .then((perfis) => this.carregarPerfis(perfis))
        .catch(() => this.mensagemService.addErro('Erro', 'Erro ao carregar as Recurso Segurança do perfil'))
        .finally(() => this.progressoService.fechar());
    } else {
      this.perfilService
        .recuperarDisponiveisParaRecursoSegurancaId(recursoSegurancaId)
        .then((perfis) => this.carregarPerfis(perfis))
        .catch(() => this.mensagemService.addErro('Erro', 'Erro ao carregar as Recurso Segurança do perfil'))
        .finally(() => this.progressoService.fechar());
    }
  }

  public carregarPerfis(itens: Perfil[]) {
    itens.forEach((item) => {
      const novoPerfilRecursosSeguranca: PerfilRecursoSeguranca = {
        perfil: item,
      };
      novoPerfilRecursosSeguranca.perfil = item;
      this.perfilRecursosSeguranca.push(novoPerfilRecursosSeguranca);
    });
  }

  protected validacao() {
    this.invalid = {
      form: false,
      nome: false,
    };

    if (StringUtils.isUndefinedOrEmpty(this.entidade.nome)) {
      this.mensagemService.addErro('Erro', 'O campo NOME é obrigatório!');
      this.invalid.nome = true;
      this.invalid.form = true;
    }
    if (this.entidade.dominio === RecursoSegurancaDominio.BACKEND && this.entidade.metodo === undefined) {
      this.mensagemService.addErro('Erro', 'O campo Método é obrigatório quando dominio informado igual a Backend!');
      this.invalid.nome = true;
      this.invalid.form = true;
    }
    return !this.invalid.form;
  }

  salvar(): void {
    if (this.validacao()) {
      this.progressoService.modal();
      if (this.entidade.dominio === RecursoSegurancaDominio.FRONTEND) {
        this.entidade.metodo = RecursoSegurancaMetodo.NAO_SE_APLICA;
      }
      this.service
        .salvar(this.entidade, this.isInsercao)
        .then((recursoSeguranca) => {
          this.entidade = recursoSeguranca;
          this.progressoService.fechar();
          this.mensagemService.addSucesso('Sucesso', 'O Recurso Segurança foi salvo com sucesso');

          if (this.isInsercao) {
            this.isInsercao = false;
            this.location.go(`/recursoSeguranca/edicao/${this.entidade.id}`);
          }
        })
        .catch((resposta) => {
          this.progressoService.fechar();
          this.mensagemService.addErro('Erro ao salvar o recurso de segurança', resposta.error);
          this.progressoService.fechar();
        });
    }
  }

  iniciarInsercao(): void {
    this.isInsercao = true;
    this.entidade = this.service.newEntity();
  }

  iniciarAlteracao(entidade: RecursoSeguranca): void {
    this.isInsercao = false;
    this.entidade = entidade;
  }

  iniciarAlteracaoPorId(id: number): void {
    this.progressoService.modal();
    this.service
      .recuperarPorId(id)
      .then((recursoSeguranca) => {
        this.progressoService.fechar();
        this.iniciarAlteracao(recursoSeguranca);
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao recuperar o Recurso Segurança para edição', resposta.error);
      });
  }
}
